
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import olapSidebarDescriptor from './OlapSidebarDescriptor.json'
import SelectButton from 'primevue/selectbutton'

export default defineComponent({
    name: 'olap-sidebar',
    components: { SelectButton },
    props: {
        olap: { type: Object },
        olapDesignerMode: { type: Boolean },
        propButtons: { type: Array },
        whatIfMode: { type: Boolean },
        olapHasScenario: { type: Boolean }
    },
    emits: [
        'openCustomViewDialog',
        'drillTypeChanged',
        'showParentMemberChanged',
        'hideSpansChanged',
        'suppressEmptyChanged',
        'showPropertiesChanged',
        'openSortingDialog',
        'openMdxQueryDialog',
        'reloadSchema',
        'enableCrossNavigation',
        'openCrossNavigationDefinitionDialog',
        'openButtonWizardDialog',
        'drillThroughChanged',
        'saveOlapDesigner',
        'showOutputWizard',
        'showScenarioWizard',
        'showSaveAsNewVersion',
        'undo',
        'showAlgorithmDialog',
        'showDeleteVersions',
        'loading',
        'exportExcel'
    ],
    computed: {
        tableFunctionsVisible(): boolean {
            return (
                this.isButtonVisible('BUTTON_FATHER_MEMBERS') ||
                this.isButtonVisible('BUTTON_HIDE_SPANS') ||
                this.isButtonVisible('BUTTON_SORTING_SETTINGS') ||
                this.isButtonVisible('BUTTON_SHOW_PROPERTIES') ||
                this.isButtonVisible('BUTTON_HIDE_EMPTY') ||
                this.isButtonVisible('BUTTON_SAVE_SUBOBJECT')
            )
        }
    },
    data() {
        return {
            olapSidebarDescriptor,
            buttons: [] as any[],
            drillOn: 'position',
            enableDrillThrough: false,
            showParentMembers: false,
            hideSpans: false,
            suppressEmpty: false,
            showProperties: false,
            crossNavigation: false,
            mode: 'designer',
            olapLocked: false
        }
    },
    watch: {
        propButtons() {
            this.loadButtons()
        },
        olap() {
            this.loadOlapModelConfigValues()
        }
    },
    created() {
        this.loadButtons()
        this.loadOlapModelConfigValues()
    },
    methods: {
        loadButtons() {
            this.buttons = this.propButtons as any[]
        },
        isButtonVisible(buttonName: string) {
            let isVisible = false
            const index = this.olap?.modelConfig.toolbarVisibleButtons?.findIndex((el: any) => el === buttonName)
            if (index !== -1) isVisible = true

            return isVisible
        },
        loadOlapModelConfigValues() {
            if (this.olap) {
                this.drillOn = this.olap.modelConfig.drillType
                this.enableDrillThrough = this.olap.modelConfig.enableDrillThrough
                this.showParentMembers = this.olap.modelConfig.showParentMembers
                this.hideSpans = this.olap.modelConfig.hideSpans
                this.suppressEmpty = this.olap.modelConfig.suppressEmpty
                this.showProperties = this.olap.modelConfig.showProperties
                this.crossNavigation = this.olap.modelConfig?.crossNavigation?.buttonClicked
                this.olapLocked = this.olap.modelConfig?.status === 'locked_by_user'
            }
        },
        onDrillThroughClick() {
            this.enableDrillThrough = !this.enableDrillThrough
            this.$emit('drillThroughChanged', this.enableDrillThrough)
        },
        onShowParentMemberClick() {
            this.showParentMembers = !this.showParentMembers
            this.$emit('showParentMemberChanged', this.showParentMembers)
        },
        onHideSpansClick() {
            this.hideSpans = !this.hideSpans
            this.$emit('hideSpansChanged', this.hideSpans)
        },
        onSuppressRowsColumnsClick() {
            this.suppressEmpty = !this.suppressEmpty
            this.$emit('suppressEmptyChanged', this.suppressEmpty)
        },
        onShowPropertiesClick() {
            this.showProperties = !this.showProperties
            this.$emit('showPropertiesChanged', this.showProperties)
        },
        onEnableCrossNavigationClick() {
            this.crossNavigation = !this.crossNavigation
            this.$emit('enableCrossNavigation', this.crossNavigation)
        },
        closeOlapDesigner() {
            this.$router.push('/document-browser')
        },
        async changeLock() {
            if (!this.olap) return
            this.$emit('loading', true)
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/locker/${this.olap.modelConfig.artifactId}`, null, {
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'application/json;charset=UTF-8',
                        'X-Disable-Errors': 'true'
                    }
                })
                .then((response: AxiosResponse<any>) => {
                    if ((response.data.status === 'unlocked' || response.data.status === 'locked_by_user' || response.data.status === 'locked_by_other') && this.olap) {
                        this.$store.commit('setInfo', {
                            msg: this.$t('common.toast.success')
                        })
                        this.olapLocked = false
                    }
                })
                .catch(() => {})
            this.$emit('loading', false)
        }
    }
})
